<ng-content select="[item-left]"> </ng-content>
<div class="label-wrapper">
  <ng-content select="cs-label"> </ng-content>
  <ng-content select="cs-tooltip"></ng-content>
</div>
<ng-content select="cs-form-field"></ng-content>
<ng-content select="cs-radio"></ng-content>
<ng-content select="cs-checkbox"></ng-content>
<ng-content select="cs-toggle"></ng-content>
<ng-content select="cs-select"></ng-content>
<ng-content select="input-calendar"></ng-content>
<ng-content select="cs-input-time"></ng-content>
<ng-content select="cs-input-measure"></ng-content>
<ng-content select="cs-input"> </ng-content>
<ng-content select="cs-textarea"> </ng-content>
<ng-content select="cs-button"> </ng-content>
<ng-content select="input"> </ng-content>
<ng-content select="[item-right]"> </ng-content>
<ng-content select="button"></ng-content>
<ng-content></ng-content>